import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import StudentUpcomingClass from './StudentUpcomingClass'
import UpcomingClassesHeader from '../../../../pages/common/Statistic/UpcomingClassesHeader'
import UsePagination from '../../../pagination'
import TutorDetails from '../../../../pages/student/FindTutor/TutorDetails'

import {
  selectLoadingStudentUpcomingClasses,
  selectStudentUpcomingClassesPagination,
} from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'
import { getStudentUpcomingClasses } from '../../../../routing/fetchingfunction/dashboard/dashboard.action'

import { getPaginationTotalLength } from '../../../../helpers'
import getUpcomingClassesFilters from '../../../../helpers/getUpcomingClassesFilters'

const StudentUpcomingClasses = () => {
  const dispatch = useDispatch()

  const {
    studentUpcomingClasses,
    studentUpcomingClassesPage,
    studentUpcomingClassesPageSize,
    studentUpcomingClassesTotal,
  } = useSelector(selectStudentUpcomingClassesPagination)
  const isLoading = useSelector(selectLoadingStudentUpcomingClasses)

  const [isTutorDetailsModalOpen, setIsTutorDetailsModalOpen] = useState(false)
  const [classBannerDetails, setClassBannerDetails] = useState(null)
  const [filters, setFilters] = useState({
    sort: 'closest',
    category: '',
    gender: '_',
    languages: '_',
    country_of_origin: '_',
    country_of_residence: '_',
    search: '',
  })

  const handleOpenTutorDetailsModal = (classBanner) => {
    setClassBannerDetails(classBanner)
    setIsTutorDetailsModalOpen(true)
  }

  const handleCloseTutorDetailsModal = () => {
    setIsTutorDetailsModalOpen(false)

    setTimeout(() => {
      setClassBannerDetails(null)
    }, 300)
  }

  const handlePageChange = (_, value) => {
    if (value !== studentUpcomingClassesPage) {
      dispatch(
        getStudentUpcomingClasses({
          page: value,
          ...getUpcomingClassesFilters(filters),
        })
      )
    }
  }

  useEffect(() => {
    dispatch(
      getStudentUpcomingClasses({
        page: 1,
        ...getUpcomingClassesFilters(filters),
      })
    )
  }, [filters])

  const upcomingClassesContent = studentUpcomingClasses.map((upcomingClass) => {
    return (
      <StudentUpcomingClass
        key={upcomingClass.id}
        upcomingClass={upcomingClass}
        onDetails={handleOpenTutorDetailsModal}
      />
    )
  })

  return (
    <div className="w-full mt-[48px]">
      <UpcomingClassesHeader filters={filters} setFilters={setFilters} />

      {upcomingClassesContent}

      {studentUpcomingClassesTotal > studentUpcomingClassesPageSize && (
        <div className="w-full flex items-center justify-center">
          <UsePagination
            count={getPaginationTotalLength(
              studentUpcomingClassesTotal,
              studentUpcomingClassesPageSize
            )}
            page={studentUpcomingClassesPage}
            onChange={handlePageChange}
            loading={isLoading}
          />
        </div>
      )}

      <TutorDetails
        open={isTutorDetailsModalOpen}
        classBanner={classBannerDetails}
        onClose={handleCloseTutorDetailsModal}
      />
    </div>
  )
}

export default StudentUpcomingClasses
